var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-array-view',{attrs:{"title":"GLOSSARY","array":_vm.glossary,"name-key":"name","description-key":"description"}})}
var staticRenderFns = []

export { render, staticRenderFns }